module.exports = __webpack_public_path__ + "img/Priest-dwarf-f-60.271dbef6.gif";